import { render, staticRenderFns } from "./combat-task.vue?vue&type=template&id=3dc41d2c&scoped=true&"
import script from "./combat-task.vue?vue&type=script&lang=js&"
export * from "./combat-task.vue?vue&type=script&lang=js&"
import style0 from "./combat-task.vue?vue&type=style&index=0&id=3dc41d2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc41d2c",
  null
  
)

export default component.exports